export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8075.6f928fb4.jpg";